export const environment = {
    production: false,
    apiUrls: {
        accountService: 'https://backend-prepaga-app-dev.geamovil.com/account',
        notificacionService: 'https://backend-prepaga-app-dev.geamovil.com/notificaciones-institucionales',
        profilePersonService: 'https://backend-prepaga-app-dev.geamovil.com/datos-personales/catalogos'
    }
};